import React from 'react';

const ArrowIcon = ({ customClass = '', variant = 'default', direction = 'down' }) => {
  if (variant === 'box') {
    const boxRotation = direction === 'down' ? 'rotate(180deg)' : 'rotate(0deg)';
    return (
      <svg
        width="28"
        height="28"
        viewBox="0 0 31 31"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`transition-transform duration-300 ${customClass}`}
      >
        <rect
          x="-0.5"
          y="0.5"
          width="30"
          height="30"
          rx="4.5"
          transform="matrix(-1 0 0 1 30 0)"
          fill="white"
          stroke="#1C1B1F"
        />
        <mask
          id="mask0"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="3"
          y="2"
          width="24"
          height="24"
        >
          <rect width="24" height="24" transform="matrix(1 0 0 -1 3 26)" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0)">
          <mask
            id="mask1"
            style={{ maskType: 'alpha' }}
            maskUnits="userSpaceOnUse"
            x="-2"
            y="-4"
            width="34"
            height="36"
          >
            <rect width="33.73" height="36" transform="matrix(1 0 0 -1 -2 32)" fill="#D9D9D9" />
          </mask>
          <g mask="url(#mask1)">
            <g
              style={{
                transform: boxRotation,
                transformOrigin: '15.5px 15.5px',
                transition: 'transform 300ms',
              }}
            >
              <path
                d="M14.8651 8.9L6.43257 17.9L8.40016 20L14.8651 13.1L21.33 20L23.2976 17.9L14.8651 8.9Z"
                fill="#1C1B1F"
              />
            </g>
          </g>
        </g>
      </svg>
    );
  }

  // Default variant
  const defaultRotation = direction === 'up' ? 'rotate(180deg)' : 'rotate(0deg)';
  return (
    <svg
      className={`w-6 h-6 text-gray-500 ${customClass}`}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <g
        style={{
          transform: defaultRotation,
          transformOrigin: '12px 12px',
          transition: 'transform 300ms',
        }}
      >
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
      </g>
    </svg>
  );
};

export default ArrowIcon;
